import { render, staticRenderFns } from "./productCreate.vue?vue&type=template&id=9a753194&"
import script from "./productCreate.vue?vue&type=script&lang=js&"
export * from "./productCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports